import { ButtonLink } from "components/styles";
import TooltipButton from "components/TooltipButton/TooltipButton";
import { getDateAsNumericText, getDatePartsByMillis } from "components/CustomDatePicker/utils/helpers";
import { getTextTimeByMinutes } from "components/CustomTimePicker/utils";
import {
    SummaryCard,
    SummaryCardHeader,
    SummaryCardTitle,
    TooltipContent,
    TooltipDate,
    TooltipEllipsis,
    TooltipItem,
    TooltipTime,
    TooltipTrigger
} from "./styles";

const MAX_VISIBLE_ITEMS = 3;

const sortInactivities = (first, second) => {
    const firstDate = first?.date || 0;
    const secondDate = second?.date || 0;
    if (firstDate !== secondDate)
        return firstDate - secondDate;

    const firstStart = first?.time?.start || 0;
    const secondStart = second?.time?.start || 0;
    if (firstStart !== secondStart)
        return firstStart - secondStart;

    const firstEnd = first?.time?.end || 0;
    const secondEnd = second?.time?.end || 0;
    return firstEnd - secondEnd;
};

const getDateText = date => {
    if (!date || date < 0)
        return null;

    return getDateAsNumericText(getDatePartsByMillis(date));
};

const getTimeRangeText = ({ time }) => {
    return `${getTextTimeByMinutes(time.start)} a ${getTextTimeByMinutes(time.end)}`;
};

const InactivitySummaryCard = ({
    disabled,
    hasError,
    inactivity = [],
    onEdit
}) => {
    const tooltipItems = [...inactivity].sort(sortInactivities);
    const cardClassName = [
        disabled ? "disabled" : "",
        hasError ? "error" : ""
    ].filter(Boolean).join(" ");

    const openEditor = event => {
        event?.stopPropagation?.();
        if (!disabled)
            onEdit();
    };

    return (
        <SummaryCard
            className={cardClassName}
            onClick={openEditor}>
            <SummaryCardHeader>
                <SummaryCardTitle>Inactividad</SummaryCardTitle>
                <TooltipTrigger onClick={event => event.stopPropagation()}>
                    <TooltipButton
                        size={20}
                        tooltipProps={{
                            x: "25%",
                            y: "-75%",
                            width: "220px",
                            after: {
                                x: "-560%",
                                y: "-160%",
                                angle: "135deg"
                            }
                        }}
                        content={
                            <TooltipContent>
                                {tooltipItems.slice(0, MAX_VISIBLE_ITEMS).map((item, idx) => (
                                    <TooltipItem key={`${item.date || idx}-${item.time.start}-${item.time.end}`}>
                                        <TooltipTime>{getTimeRangeText(item)}</TooltipTime>
                                        {getDateText(item.date) && (
                                            <TooltipDate>{getDateText(item.date)}</TooltipDate>
                                        )}
                                    </TooltipItem>
                                ))}
                                {tooltipItems.length > MAX_VISIBLE_ITEMS && (
                                    <TooltipEllipsis>...</TooltipEllipsis>
                                )}
                            </TooltipContent>
                        } />
                </TooltipTrigger>
            </SummaryCardHeader>
            <ButtonLink
                margin="0"
                className={disabled ? "disabled" : ""}
                onClick={openEditor}>
                Editar
            </ButtonLink>
        </SummaryCard>
    );
};

export default InactivitySummaryCard;
